export default "__VITE_ASSET__wrMt$w1s__"